<template>
  <div class="investor-add-manager-form">
    <div class="investor-add-manager-form__upper">
      <div class="investor-add-manager-form__upper__inputs">
        <b-form-row>
          <b-col sm="6">
            <FormItem
              label="First name"
              invalid-message="Please enter first name"
              :state="
                $v.addForm.name.first.$dirty
                  ? !$v.addForm.name.first.$error
                  : null
              "
              required
            >
              <b-form-input
                v-model="addForm.name.first"
                maxlength="50"
                :state="
                  $v.addForm.name.first.$dirty
                    ? !$v.addForm.name.first.$error
                    : null
                "
              />
            </FormItem>
          </b-col>
          <b-col>
            <FormItem
              label="Last name"
              invalid-message="Please enter last name"
              :state="
                $v.addForm.name.last.$dirty
                  ? !$v.addForm.name.last.$error
                  : null
              "
              required
            >
              <b-form-input
                v-model="addForm.name.last"
                maxlength="50"
                :state="
                  $v.addForm.name.last.$dirty
                    ? !$v.addForm.name.last.$error
                    : null
                "
              />
            </FormItem>
          </b-col>
        </b-form-row>
        <FormItem
          label="Email"
          invalid-message="Please enter a valid email"
          :state="$v.addForm.email.$dirty ? !$v.addForm.email.$error : null"
          required
        >
          <b-form-input
            v-model="addForm.email"
            maxlength="100"
            :state="$v.addForm.email.$dirty ? !$v.addForm.email.$error : null"
            required
          />
        </FormItem>
      </div>
    </div>

    <div class="d-flex">
      <button class="btn mt-16 px-40 mr-10" @click="onSubmit()">
        {{ editing ? 'Save' : 'Add' }}
      </button>
      <button
        v-if="editing"
        class="btn mt-16 px-40 btn-gray"
        @click="$emit('cancel')"
      >
        Cancel
      </button>
    </div>
  </div>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required, email, maxLength } from 'vuelidate/lib/validators'
import cloneDeep from 'lodash/cloneDeep'
import FormItem from '@/components/form/FormItem'

const initialFormValues = {
  name: {
    first: undefined,
    last: undefined
  },
  email: undefined
}

export default {
  name: 'InvestorAddManagersForm',
  components: {
    FormItem
  },
  mixins: [validationMixin],
  props: {
    useUserAsPlaceholder: Boolean,
    editing: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      addForm: cloneDeep(initialFormValues)
    }
  },
  computed: {
    user() {
      return this.$store.state.user.data
    }
  },
  watch: {
    editing: 'updateFromEdit'
  },
  created() {
    if (this.useUserAsPlaceholder) {
      this.addForm.name = this.user.name
    }

    if (this.editing) {
      this.updateFromEdit(this.editing)
    }
  },
  methods: {
    updateFromEdit(item) {
      if (item) {
        this.addForm = Object.assign(
          cloneDeep(initialFormValues),
          cloneDeep(item)
        )
      } else {
        this.addForm = cloneDeep(initialFormValues)
      }
    },
    onSubmit() {
      this.$v.$touch() // will trigger errors to appear.
      if (this.$v.$error) {
        return
      }

      this.$emit('add', {
        ...this.addForm
      })

      this.addForm = cloneDeep(initialFormValues)

      this.$v.$reset()
    }
  },
  validations() {
    return {
      addForm: {
        name: {
          first: {
            required,
            maxLength: maxLength(50)
          },
          last: {
            required,
            maxLength: maxLength(50)
          }
        },
        email: {
          required,
          email
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.investor-add-manager-form {
  &__upper {
    display: flex;

    &__inputs {
      flex: 1 1 auto;
    }

    &__image {
      margin-left: 1.5rem;
      margin-top: 2.1rem;
      flex: 0 0 auto;
      width: 175px;
      height: 175px;
    }
  }
}
</style>
